var levels = [];

//v= value;
//l= level;
levels.push({
  matrix: [
    [
      { v: 1, l: 0 },
      { v: 1, l: 0 },
      { v: 3, l: 0 },
    ],
    [
      { v: 2, l: 0 },
      { v: 1, l: 0 },
      { v: 1, l: 0 },
    ],
    [
      { v: 1, l: 0 },
      { v: 1, l: 0 },
      { v: 2, l: 0 },
    ],
    [
      { v: 1, l: 0 },
      { v: 2, l: 0 },
      { v: 1, l: 0 },
    ],
  ],
});
